import { render, staticRenderFns } from "./dictbiz.vue?vue&type=template&id=504e9a99&scoped=true"
import script from "./dictbiz.vue?vue&type=script&lang=js"
export * from "./dictbiz.vue?vue&type=script&lang=js"
import style0 from "./dictbiz.vue?vue&type=style&index=0&id=504e9a99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504e9a99",
  null
  
)

export default component.exports